import { takeLatest, put } from 'redux-saga/effects';

import {
  identificadorCadastro,
  NEW_IDENTIFICADOR_CADASTRO,
  NEW_IDENTIFICADOR_CADASTRO_SUCCESS,
} from '@handler';

function* sagaNewIdentificadorCadastro(action) {

  yield put({
    type: NEW_IDENTIFICADOR_CADASTRO_SUCCESS,
    registro: identificadorCadastro.newRegistro,
    isCadastroRapido: action.isCadastroRapido,
    status: true,
  });
}

export default function* watchNewIdentificadorCadastro() {
  yield takeLatest(NEW_IDENTIFICADOR_CADASTRO, sagaNewIdentificadorCadastro)
}
